import React, { Fragment, ReactElement } from 'react';
import { TerminDetail } from 'tezaury-frontend-ts-axios';
import { useNavigate } from 'react-router';
import { Link } from 'idsk-react-components';
import { useResponsiveContext } from 'slovlex-idsk-react-components';
import DetailTerminuSectionHeading
  from '../DetailTerminuSectionHeading/DetailTerminuSectionHeading';
import DetailTerminuRow from '../DetailTerminuRow/DetailTerminuRow';
import TerminDetailEmptyDataMessage
  from '../TerminDetailEmptyDataMessage/TerminDetailEmptyDataMessage';
import routes from '../../../routing/routes';
import './detailTerminuDefinicie.scss';
import TerminDetailMobileItem from './component/TerminDetailMobileItem';

interface Props {
  termin: TerminDetail;
  admin?: boolean;
}

const DetailTerminuDefinicie = ({ termin, admin = false }: Props): ReactElement => {
  const navigate = useNavigate();
  const { isSmallScreen } = useResponsiveContext();
  return (
    <>
      {(admin || termin.legalneDefinicieList.length > 0) && (
        <div className="detail-legalne-definicie">
          <DetailTerminuSectionHeading
            heading="Legálne definície"
            admin={admin}
            onClick={() => navigate(routes.tezaurus.admin.termin.edit.legalneDefinicie
              .withParams(termin.tezaurus.uuid, termin.uuid))}
            terminListNotEmpty={termin.legalneDefinicieList.length > 0}
          />

          {termin.legalneDefinicieList.length === 0 && (
          <TerminDetailEmptyDataMessage text="Termín nemá žiadne legálne definície." />
          )}

          {isSmallScreen ? (
            termin.legalneDefinicieList.map((legalnaDefinicia, index) => (
              <TerminDetailMobileItem
                key={`terminDetailMobileItemComponentKey-${legalnaDefinicia.uuid}`}
                headerDefinicia={
                            termin.legalneDefinicieList.length === 1
                              ? 'Legálna definícia'
                              : `Legálna definícia ${index + 1}`
                          }
                headerZdroj={
                            termin.legalneDefinicieList.length === 1
                              ? 'Zdroj definície'
                              : `Zdroj definície ${index + 1}`
                          }
                definicia={legalnaDefinicia.definicia}
                zdroj={legalnaDefinicia.popisLegislativnehoZdroja ? legalnaDefinicia.popisLegislativnehoZdroja : '-'}
                link={legalnaDefinicia.zdroj}
              />
            ))
          ) : (
            termin.legalneDefinicieList.map((legDefinicia, index) => (
              <Fragment key={`${legDefinicia.uuid}`}>
                <DetailTerminuRow
                  header={
                              termin.legalneDefinicieList.length === 1
                                ? 'Legálna definícia'
                                : `Legálna definícia ${index + 1}`
                            }
                >
                  {legDefinicia.definicia}
                </DetailTerminuRow>
                <DetailTerminuRow
                  header={
                              termin.legalneDefinicieList.length === 1
                                ? 'Zdroj definície'
                                : `Zdroj definície ${index + 1}`
                            }
                >
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {legDefinicia.popisLegislativnehoZdroja
                    ? (
                      <Link
                        className="zdroj-legalnej-definicie-button-link"
                        to={`${process.env.REACT_APP_PORTAL_MAIN_URL}/ezbierky/pravne-predpisy${legDefinicia.zdroj}`}
                        onClick={() => {
                          window.parent.postMessage(
                            {
                              type: 'iframe-to-parent-external-route',
                              route: `/ezbierky/pravne-predpisy${legDefinicia.zdroj}`,
                            },
                            '*',
                          );
                        }}
                      >
                        {legDefinicia.popisLegislativnehoZdroja}
                      </Link>
                    )
                    : (
                      <span>-</span>
                    )}
                </DetailTerminuRow>
              </Fragment>
            ))
          )}
        </div>
      )}

      {(admin || termin.doktrinalneDefinicieList.length > 0) && (
        <div className="detail-doktrinalne-definicie">
          <DetailTerminuSectionHeading
            heading="Doktrinálne definície"
            admin={admin}
            onClick={() => navigate(
              routes.tezaurus.admin.termin.edit.doktrinalneDefinicie.withParams(
                termin.tezaurus.uuid,
                termin.uuid,
              ),
            )}
            terminListNotEmpty={termin.doktrinalneDefinicieList.length > 0}
          />

          {termin.doktrinalneDefinicieList.length === 0 && (
          <TerminDetailEmptyDataMessage text="Termín nemá žiadne doktrinálne definície." />
          )}

          {isSmallScreen ? (
            termin.doktrinalneDefinicieList.map((doktrinalnaDefinicia, index) => (
              <TerminDetailMobileItem
                key={`terminDetailMobileItemComponentKey-${doktrinalnaDefinicia.uuid}`}
                headerDefinicia={
                            termin.doktrinalneDefinicieList.length === 1
                              ? 'Doktrinálna definícia'
                              : `Doktrinálna definícia ${index + 1}`
                          }
                headerZdroj={
                            termin.doktrinalneDefinicieList.length === 1
                              ? 'Zdroj definície'
                              : `Zdroj definície ${index + 1}`
                          }
                definicia={doktrinalnaDefinicia.definicia}
                zdroj={doktrinalnaDefinicia.zdroj ? doktrinalnaDefinicia.zdroj : '-'}
              />
            ))
          ) : (
            termin.doktrinalneDefinicieList.map((doktrinalnaDefinicia, index) => (
              <Fragment key={`${doktrinalnaDefinicia.uuid}`}>
                <DetailTerminuRow
                  header={
                              termin.doktrinalneDefinicieList.length === 1
                                ? 'Doktrinálna definícia'
                                : `Doktrinálna definícia ${index + 1}`
                            }
                >
                  {doktrinalnaDefinicia.definicia}
                </DetailTerminuRow>
                <DetailTerminuRow
                  header={
                              termin.doktrinalneDefinicieList.length === 1
                                ? 'Zdroj definície'
                                : `Zdroj definície ${index + 1}`
                            }
                >
                  {doktrinalnaDefinicia.zdroj ? doktrinalnaDefinicia.zdroj : '-'}
                </DetailTerminuRow>
              </Fragment>
            ))
          )}
        </div>
      )}
    </>
  );
};

export default DetailTerminuDefinicie;
